import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import { AbilityService } from '../services/ability.service';

@Injectable()
export class AuthGuard {

   abilityService = inject(AbilityService)
   ability = this.abilityService.getAbilitiesChecker()


  constructor(
    private router: Router, 
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot): boolean {
    const token = sessionStorage.getItem('token');
    if (!token) {
      this.router.navigate(['login']);
      return false;
    }
    const auth = next.data['auth'];
    if (!auth || this.ability.can(auth.action, auth.subject)) {
      return true;
    }
    this.router.navigate(['forbidden']);
    return false;
  }

}
